/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of conditional workflow rules.
 */
export enum TimeFrameRuleType {
    WITHIN_TIME_FRAME = 'WithinTimeFrame',
    NOT_WITHIN_TIME_FRAME = 'NotWithinTimeFrame',
}
